import styled from "styled-components"
import { mobile, smallScreen } from "../../Responsive"


export const Container = styled.div`
    display: flex;
    justify-content: space-between;

    ${mobile({ flexDirection: "column" })}
`

export const FilterElement = styled.div`
    flex: 1;
    margin: 20px 20px;

    ${mobile({ margin: "0 10px", display: "flex", flexDirection: "column" })}
`

export const FilterText = styled.span`
    font-size: var(--fontL);
    font-weight: 600;

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontM);
        margin-right: 10px;
    }
`

export const CheckboxGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 1em 0;
`

export const RadioLabel = styled.label`
    font-size: var(--fontM);
    line-height: 1.1;
    display: grid;
    grid-template-columns: 1em auto;
    gap: 0.5em;
    margin-top: 0.5em;

    :focus-within {
        color: var(--secondary);
    }
    
    ${mobile({marginTop: "0.25em"})}
`

export const RadioInput = styled.input`
    appearance: none;
    font: inherit;
    color: var(--secondary);
    width: 1.15em;
    height: 1.15em;
    border: 0.15em solid currentColor;
    border-radius: 50%;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;

    ::before {
        content: "";
        width: 0.65em;
        height: 0.65em;
        border-radius: 50%;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em var(--secondary);
    }
    
    :checked::before {
        transform: scale(1);
    }
`